import { useMutation } from "@tanstack/react-query";
import { requestPasswordReset, requestEmailChange } from "./services/AuthService";

export function useRequestPasswordResetMutation() {
  return useMutation({
    mutationFn: () => requestPasswordReset(),
  });
}

export function useRequestEmailChangeMutation() {
  return useMutation({
    mutationFn: (newEmail: string) => requestEmailChange(newEmail),
  });
}
